import type { IFilterableListItem, IMultiSelectProps, IOmit } from '@sixui/ui';
import { forwardRef } from 'react';
import { MultiSelect } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

export type IAppRolesSelectorProps = IOmit<IMultiSelectProps, 'items'>;

export const AppRolesSelector = forwardRef<
  HTMLInputElement,
  IAppRolesSelectorProps
>(function AppRolesSelector(props, forwardedRef) {
  const { ...other } = props;
  const { t } = useTranslation();
  const items: Array<IFilterableListItem> = [
    {
      value: 'viewer',
      label: t('AppRoleSelector.viewer.label'),
      supportingText: t('AppRoleSelector.viewer.supporting-text'),
      disabled: true,
    },
    {
      value: 'editor',
      label: t('AppRoleSelector.editor.label'),
      supportingText: t('AppRoleSelector.editor.supporting-text'),
      disabled: true,
    },
    {
      value: 'moderator',
      label: t('AppRoleSelector.moderator.label'),
      supportingText: t('AppRoleSelector.moderator.supporting-text'),
      disabled: true,
    },
    {
      value: 'admin',
      label: t('AppRoleSelector.admin.label'),
      supportingText: t('OrganizationRoleSelector.admin.supportingText'),
    },
  ];

  return <MultiSelect {...other} items={items} ref={forwardedRef} />;
});
